import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function WorkerVerifyPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyToken = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setError('Token no proporcionado');
        return;
      }

      try {
        const response = await axios.post(`${API_URL}/api/worker-portal/verify`, { token });
        
        // Store worker session
        localStorage.setItem('worker_token', response.data.access_token);
        localStorage.setItem('worker_user', JSON.stringify(response.data.worker));
        
        setStatus('success');
        toast.success('Acceso verificado');
        
        // Redirect to dashboard after brief delay
        setTimeout(() => {
          navigate('/worker/dashboard');
        }, 1500);
        
      } catch (error) {
        setStatus('error');
        setError(error.response?.data?.detail || 'Error al verificar token');
      }
    };

    verifyToken();
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen ios-page flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {status === 'loading' && (
          <>
            <Loader2 className="w-16 h-16 text-orange-500 mx-auto mb-6 animate-spin" />
            <h1 className="text-2xl font-bold text-[#1D1D1F] mb-2">Verificando acceso...</h1>
            <p className="text-[#AEAEB2]">Espera un momento</p>
          </>
        )}

        {status === 'success' && (
          <>
            <div className="w-20 h-20 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-green-500" />
            </div>
            <h1 className="text-2xl font-bold text-[#1D1D1F] mb-2">Acceso verificado</h1>
            <p className="text-[#AEAEB2]">Redirigiendo al panel...</p>
          </>
        )}

        {status === 'error' && (
          <>
            <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-10 h-10 text-red-500" />
            </div>
            <h1 className="text-2xl font-bold text-[#1D1D1F] mb-2">Error de verificacion</h1>
            <p className="text-[#AEAEB2] mb-6">{error}</p>
            <button
              onClick={() => navigate('/worker')}
              className="px-6 py-3 bg-white/55 text-[#1D1D1F] rounded-xl hover:bg-white/60 transition-colors"
            >
              Volver al login
            </button>
          </>
        )}
      </div>
    </div>
  );
}
